const linkResolver = (doc) => {
    if (doc.type === 'page' || doc.type === 'blog') {
      return `/${doc.uid}`
    }
    return '/'
  }
  
  module.exports = linkResolver